module.exports = __webpack_public_path__ + "files/a4aabc96f66fe76874f26bf74a6d0a02.png";